export default "__VITE_ASSET__CG4RiCQq__"